import React, { useMemo, useRef } from "react";
import { Column, Row } from "react-table";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import moment from "moment";

import "./Imports.scss";
import { getOffPlatformsListing } from "api/services/fileImport";
import DataTable from "components/organisms/DataTable/DataTable";
import useTableRequest from "hooks/useTableRequest";
import { ReactComponent as ArrowDown } from "assets/images/icons/ArrowDown.svg";
import { ReactComponent as ArrowUp } from "assets/images/icons/ArrowUp.svg";
import { ImportRequestTypes } from "constants/";
import ImportHeader from "./components/ImportHeader";
import ImportQuoteList from "./components/ImportQuoteList";
import ImportQuickList from "./components/ImportQuickList";
import ImportShipmentList from "./components/ImportShipmentList";

const IMPORT_DETAIL_COMPONENT = {
  [ImportRequestTypes.QUICK]: ImportQuickList,
  [ImportRequestTypes.QUOTE]: ImportQuoteList,
  [ImportRequestTypes.TRACKING]: ImportShipmentList,
};

function Imports() {
  const [searchParams] = useSearchParams();
  const headerRef = useRef<any>(null);
  const importType: string = searchParams.get("import_type") || "";
  const intl = useIntl();
  const navigate = useNavigate();

  const columns = useMemo<Column[]>(
    () => [
      {
        id: "created",
        Header: intl.formatMessage({
          id: "general.created",
          defaultMessage: "Created",
        }),
        accessor: "created",
        Cell: ({ value }: any) => (
          <div className="d-flex align-items-center">
            <p className="font-weight-bold mb-0">{moment(value, "YYYY-MM-DD HH:mm:ss").format("DD MMM YY") || "-"}</p>
            <p className="mb-0 ml-1">{moment(value, "YYYY-MM-DD HH:mm:ss").format("HH:mm UTC") || "-"}</p>
          </div>
        ),
      },
      {
        id: "type",
        Header: intl.formatMessage({
          id: "general.type",
          defaultMessage: "Type",
        }),
        accessor: "metadata.imported_objects_type",
        Cell: ({ value }: any) => <p className="mb-0">{value || "-"}</p>,
      },
      {
        id: "count",
        Header: intl.formatMessage({
          id: "imports.imported",
          defaultMessage: "Imported",
        }),
        accessor: "metadata.imported_objects_count",
        Cell: ({ value }: any) => <p className="mb-0">{value || "-"}</p>,
      },
      {
        id: "user",
        Header: intl.formatMessage({
          id: "general.user",
          defaultMessage: "User",
        }),
        accessor: "created_by",
        Cell: ({ value }: any) => <p className="mb-0">{value || "-"}</p>,
      },
      {
        Header: () => null,
        id: "expander",
        Cell: ({ row }: any) => <div>{row.isExpanded ? <ArrowUp /> : <ArrowDown />}</div>,
      },
    ],
    [],
  );

  const { instance, fetching, totalData } = useTableRequest(getOffPlatformsListing, columns);

  const handleRowClick = (row: Row) => {
    row.toggleRowExpanded();
  };


  return (
    <div className="imports-wrapper">
      <ImportHeader onUploadClick={() => navigate('/settings/file-import-tools')} customRef={headerRef} />
      <div>
        <DataTable
          tableInstance={instance}
          isLoading={fetching}
          totalData={totalData}
          draggable={false}
          onRowClick={handleRowClick}
          RowSubComponent={IMPORT_DETAIL_COMPONENT[importType]}
        />
      </div>
    </div>
  );
}

export default Imports;
